import { useAuth0 } from "@auth0/auth0-react"
import { requestGET } from "../services/request"
import { useQuery } from "@tanstack/react-query"

export const useDevices = (limit?: number) => {
  const auth = useAuth0()
  return useQuery({
    queryKey: ['devices', limit], queryFn: async () => {
      const response = requestGET(
        limit ? `iot/devices?limit=${limit}` :`iot/devices`,
        undefined,
        auth,
      )
      return response
    }
  })

}
